import { render, staticRenderFns } from "./ForwardedRequests.vue?vue&type=template&id=070ed4f4&"
import script from "./ForwardedRequests.vue?vue&type=script&lang=js&"
export * from "./ForwardedRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports